import React from 'react';

import DashboardTopBar from '@core/dashboard/components/DashboardTopBar';
import HomeBottomBar from '@core/dashboard/components/HomeBottomBar';
import { StreamingProviders } from '@core/dashboard/providers/MytaverseEventProvider/interfaces';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { env } from 'env';
import { useEventContext } from '@providers/EventProvider';

const DashboardBarButtons = () => {
  const { isEventRun } = useEventContext();
  const {
    showControls,
    gameReadyToPlay,
    streamingProvider,
    isHideWebUI,
    currentEvent,
  } = useMytaverseEvent();

  const isBarVisible = () => {
    const visibleControls = isEventRun && showControls;

    switch (streamingProvider) {
      case StreamingProviders.CoreWeave:
        return gameReadyToPlay && visibleControls;

      default:
        return visibleControls;
    }
  };
  const hasExternalEventTag = env.REACT_APP_EXTERNAL_EVENT_TAG
    ? currentEvent?.eventTags?.includes(env.REACT_APP_EXTERNAL_EVENT_TAG) ===
      true
    : false;

  if (!isBarVisible() || (isHideWebUI.flag && !hasExternalEventTag)) {
    return null;
  }

  return (
    <>
      <DashboardTopBar />
      <HomeBottomBar />
    </>
  );
};

export default DashboardBarButtons;
